import { useEffect } from 'react';
import { useLocation } from 'react-router';

type FaviconKind = 'stand' | 'tutor' | 'student';

type FaviconSet = {
  svg: string;
  png: string;
  ico: string;
  themeColor: string;
};

const ICONS: Record<FaviconKind, FaviconSet> = {
  stand: {
    svg: '/favicon.svg',
    png: '/favicon-120.png',
    ico: '/favicon.ico',
    themeColor: '#CC4C4C',
  },
  tutor: {
    svg: '/favicon-tutor.svg',
    png: '/favicon-tutor-120.png',
    ico: '/favicon-tutor.ico',
    themeColor: '#354894',
  },
  student: {
    svg: '/favicon-student.svg',
    png: '/favicon-student-120.png',
    ico: '/favicon-student.ico',
    themeColor: '#CA6724',
  },
};

function upsertLink(attrs: { rel: string; href: string; type?: string; sizes?: string }) {
  const key = [attrs.rel, attrs.type ?? '', attrs.sizes ?? ''].join('|');
  let el = document.head.querySelector<HTMLLinkElement>(`link[data-mt-favicon="${key}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('data-mt-favicon', key);
    document.head.appendChild(el);
  }
  el.rel = attrs.rel;
  el.href = attrs.href;
  if (attrs.type) {
    el.type = attrs.type;
  } else {
    el.removeAttribute('type');
  }
  if (attrs.sizes) {
    el.setAttribute('sizes', attrs.sizes);
  } else {
    el.removeAttribute('sizes');
  }
}

function applyFavicon(kind: FaviconKind) {
  const icons = ICONS[kind];
  upsertLink({ rel: 'icon', type: 'image/svg+xml', href: icons.svg });
  upsertLink({ rel: 'icon', type: 'image/png', sizes: '120x120', href: icons.png });
  upsertLink({ rel: 'shortcut icon', href: icons.ico });

  let theme = document.head.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!theme) {
    theme = document.createElement('meta');
    theme.name = 'theme-color';
    document.head.appendChild(theme);
  }
  theme.content = icons.themeColor;
}

function faviconKindFromPath(pathname: string): FaviconKind {
  if (pathname.startsWith('/teacher')) {
    return 'tutor';
  }
  if (pathname.startsWith('/profile')) {
    return 'student';
  }
  return 'stand';
}

export const RoleFavicon = () => {
  const { pathname } = useLocation();
  const kind = faviconKindFromPath(pathname);

  useEffect(() => {
    applyFavicon(kind);
  }, [kind]);

  return null;
};
